import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';

// MUI
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

type FormSectionTitleType = {
  titleToken?: string
  fontSize?: string | number
}

const FormSectionTitle: FC<FormSectionTitleType> = (props) => {
  const { titleToken, fontSize } = props;
  const { t } = useTranslation();

  return titleToken ? (
    <Grid size={12}>
      <Typography variant="h6" component="h2" p={0} fontSize={fontSize}>
        {t(titleToken)}
      </Typography>
    </Grid>
  ) : null;

}

export default FormSectionTitle;
